import { render, staticRenderFns } from "./FollowupV5.vue?vue&type=template&id=ce9726ca"
import script from "./FollowupV5.vue?vue&type=script&lang=js"
export * from "./FollowupV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports